import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { day, apiError } from '../utils/format';

const LABEL = { off: 'Off / leave', halfday: 'Half day', absent: 'Absent' };
const badge = (s) => ({ off: 'badge-blue', halfday: 'badge-gold', absent: 'badge-red' }[s] || 'badge-gray');

// Monthly leave/absence register, derived from the daily Attendance sheet.
const Leaves = () => {
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/employees/leaves?month=${month}`).then(({ data }) => setRows(data.entries || []))
      .catch((e) => toast.error(apiError(e))).finally(() => setLoading(false));
  }, [month]);

  return (
    <div>
      <div className="section-head">
        <div className="flex gap" style={{ alignItems: 'center' }}>
          <label className="muted small">Month</label>
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} style={{ width: 170 }} />
          <span className="muted small">{rows.length} leave/absence records</span>
        </div>
      </div>
      <p className="muted small" style={{ marginTop: '-.4rem' }}>Recorded from the daily <Link to="/attendance">Attendance</Link> sheet.</p>
      {loading ? <div className="spinner" /> : (
        <div className="table-wrap">
          <table className="grid">
            <thead><tr><th>Date</th><th>Employee</th><th>Type</th><th>Note</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{day(r.date)}</td>
                  <td><Link to={`/employees/${r.employeeId}`} className="link-strong">{r.employee?.name || `#${r.employeeId}`}</Link></td>
                  <td><span className={`badge ${badge(r.status)}`}>{LABEL[r.status] || r.status}</span></td>
                  <td className="muted">{r.note || '—'}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={4} className="empty">No leaves/absences this month.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Leaves;
